import React, { useContext } from 'react';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import './Story.css';
import OneStory from './OneStory';
import { PostsContext } from '../App';

 
 

const Story = ({user}) => {
  const [posts, setPosts] = useContext(PostsContext);

          
    return (
       <div className="fullStory">
        <div className="d-flex m-3 story">
                <div className="addStory">
                <img src={user.photoURL } alt="" className="addStoryImg"/>
                <AddCircleIcon className="adIcon"/>          
                <h4>Create Story</h4>          
                </div>
            
          {
            posts.map(({ id, post }) => 
                <OneStory key={id} user={user} proName={post.proName} proImage={post.proImage}  postImage={post.postImage}  />
            )
           }
        </div>
       </div>
    );
};
 
export default Story;